import { CoreHelper, FormatHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { Company } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$types';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useUserInput } from '@store';
import { SelectedAccount } from '@types';

export interface AccountSelectedHelperOutput {
	resources: AccountSelectedHelperResources;
	formatNumber: string;
	selectedAccount?: SelectedAccount;
}

export interface AccountSelectedHelperResources {
	enterprise: string;
	accountLinked: string;
}

export const useAccountSelectedHelper = (): AccountSelectedHelperOutput => {
	const t = useTranslation();
	const { selectedAccount } = useUserInput();

	const resources: AccountSelectedHelperResources = {
		enterprise: t('placeholders.accountSelected.enterprise'),
		accountLinked: t('placeholders.accountLinked'),
	};

	let formatNumber = '';
	if (!CoreHelper.isNullOrEmpty(selectedAccount?.account?.number)) {
		formatNumber = FormatHelper.formatAccountNumber(selectedAccount?.account?.number as string, Company.ab);
	}

	return { resources, formatNumber, selectedAccount };
};
